import filterIcon from '@assets/icons/filter.svg';
import { Button } from 'antd';

export default function AdvanceFilter({
  applyFilter,
  resetFilter,
  loadingData,
  filterForm
}) {
  return (
    <div className="w-full hidden md:block md:w-[30%] lg:w-[22%] h-fit shadow-xl animate-moveFromTop rounded-[10px] bg-opacity-90 p-6 bg-white relative">
      {/* heading */}
      <div className="flex gap-2.5 items-center">
        <img src={filterIcon} alt="filter" />
        <h1 className="font-['SF-Pro-Text-Regular, sans-serif'] text-[#1C4E9D] text-xl font-medium">
          Filter
        </h1>
      </div>

      {/* action buttons */}
      <div className="flex justify-center w-full gap-2.5 my-6 ">
        <Button
          onClick={resetFilter}
          loading={loadingData}
          className="font-['SF-Pro-Text-Regular, sans-serif'] hover:!bg-[#1C4E9D] hover:!text-white hover:!border-none !bg-transparent border border-[#1C4E9D] rounded-[4px] text-xs !text-[#1C4E9D]"
        >
          Reset Filters
        </Button>
        <Button
          loading={loadingData}
          onClick={applyFilter}
          className="font-['SF-Pro-Text-Regular, sans-serif'] hover:!bg-transparent hover:!text-[#1C4E9D] hover:!border-[#1C4E9D]  hover:border rounded-[4px] text-xs !text-white bg-[#1C4E9D]"
        >
          Apply Filters
        </Button>
      </div>

      {/* filter form */}
      {filterForm}
    </div>
  );
}
